export const WISHLIST_FEATURE_LAZY = 'wishlistFeatureLazy';
export const WISHLIST_UI_WISHLIST_BUTTON_LAZY = 'wishlistUiWishlistButtonLazy';
export const WISHLIST_UI_WISHLIST_CONTENT_LAZY = 'wishlistUiWishlistContentLazy';
